<template>
  <router-view v-if="territory"
               :territory="territory">
  </router-view>
</template>
<script>
import territoryService from '../../services/territoryService';

export default {
  data() {
    return {
      busy: false,
      territory: null,
    }
  },
  computed: {
    territoryID() {
      return parseInt(this.$route.params.territoryID);
    }
  },
  created() {
    console.log('Territory.vue create()')
    this.fetchData();
  },
  methods: {
    fetchData() {
      territoryService.getTerritory(this.territoryID)
        .then(data => {
          this.territory = data;
        })
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
